// export enum AudioSetFormat {
//   Mono = 1,
//   MonoPerPosition,
//   MonoMultiSample
// }
export var AUDIO_SETS = {
    en_us_digits: {
        // format: AudioSetFormat.MonoPerPosition,
        files: function () {
            var base = 'audio/american-digits-20180216/mono/broadband';
            var files = [];
            for (var p = 1; p <= 3; p += 1) {
                for (var n = 0; n < 10; n += 1) {
                    files.push({
                        name: "d".concat(n, "p").concat(p),
                        path: "".concat(base, "/d").concat(n, "p").concat(p, "m00db.wav.m4a"),
                    });
                }
            }
            files.push({
                name: 'noise',
                path: "".concat(base, "/English_speech_shaped_m00dB.wav.m4a"),
            });
            return files;
        },
        digitFileName: function (digit, position) { return "d".concat(digit, "p").concat(position); },
        noiseFileName: function () { return 'noise'; },
    },
    en_us_digits_2klp: {
        // format: AudioSetFormat.MonoPerPosition,
        files: function () {
            var base = 'audio/american-digits-20180216/mono/low-pass-2k';
            var files = [];
            for (var p = 1; p <= 3; p += 1) {
                for (var n = 0; n < 10; n += 1) {
                    files.push({
                        name: "d".concat(n, "p").concat(p),
                        path: "".concat(base, "/d").concat(n, "p").concat(p, "m00db.wav.m4a"),
                    });
                }
            }
            files.push({
                name: 'noise',
                path: "".concat(base, "/English_low-pass_2_kHz_m00dB.wav.m4a"),
            });
            return files;
        },
        digitFileName: function (digit, position) { return "d".concat(digit, "p").concat(position); },
        noiseFileName: function () { return 'noise'; },
    },
};
